<script lang="ts">
  import { Input } from "sveltestrap";
  import type { Third } from "../Model/Third";
  import { thirdsService } from "../services";
    import ThirdData from "./ThirdData.svelte";

  export let id: string;

  let name: string = "Sin tercero adherido";
  let third: Third;

  $: getName(id);

  async function getName(id: string) {
    if (!id) return;

    third = await thirdsService.findOne(id);

    if (third) {
      name = third.name + " " + third.surname1 + " " + third.surname2;
    }
  }

  function thirdData(third) {
    if(!confirm('¿Quiere abrir la ficha de ' + name + "?")) {
      return;
    }

    window.open("/tercero/" + third.id)
  }
</script>

<input type="text" value={name} readonly on:click={() => thirdData(third)} class='w-75 rounded-start  '/>

<style>
  input:focus {
    border: 1px solid rgba(106, 187, 255, 1);
    border-color: rgba(106, 187, 255, 1);
    outline: 4px solid rgba(56, 164, 255, 0.33);
    transition: outline .15s ease-in-out;
  }

  input:active {
    border: 1px solid rgba(106, 187, 255, 1);
    border-color: rgba(106, 187, 255, 1);
    outline: 4px solid rgba(56, 164, 255, 0.33);
  }
</style>